export default __webpack_public_path__ + "static/media/useReducer_hook_flow_chart.213065a2.jpg";